(function() {
  angular.module('cfn').factory('Person', Person);

  Person.$inject = ['dataSource.factory'];
  function Person(dataSource) {
    return dataSource('person').getRestService();
  }
})();
